import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ClaimCountOutput, ClaimOutput, ReconciliationService } from 'core/http/project';
import { Observable } from 'rxjs';

@Injectable()
export class ClaimCountResolver {
  constructor(private reconciliationService: ReconciliationService) {
  }

  resolve(): Observable<ClaimCountOutput> {
    return this.reconciliationService.getClaimCount();
  }
}

@Injectable()
export class ClaimResolver {
  constructor(private reconciliationService: ReconciliationService) {
  }

  resolve(snapshot: ActivatedRouteSnapshot): Observable<ClaimOutput> {
    return this.reconciliationService.getClaim(snapshot.params.claimId);
  }
}
